import { render, staticRenderFns } from "./ChatTelegram.vue?vue&type=template&id=72554c6e&"
import script from "./ChatTelegram.vue?vue&type=script&lang=js&"
export * from "./ChatTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports